import {css} from 'aphrodite';
import React from 'react';
import _ from 'underscore';

import {assertAndContinue} from 'Asserts';
import {
  getNameTemplatePartTypeToString,
  NameTemplatePart,
  nameTemplatePartChipStyles,
  NameTemplatePartType,
} from 'name-templates/NameTemplateConstants';
import {ClientSchemaField} from 'registry/field/FieldTable';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {ellipsize} from 'util/NameUtil';

// Exported for tests
export function _formatNameTemplatePart(
  nameTemplatePart: NameTemplatePart,
  schemaFields: Array<SchemaField | ClientSchemaField>
): JSX.Element {
  let text = '(Unknown)';
  switch (nameTemplatePart.type) {
    case NameTemplatePartType.FIELD: {
      const field = _.findWhere(schemaFields, {apiId: nameTemplatePart.fieldId});
      if (field) {
        return <span className={css(nameTemplatePartChipStyles.fieldName)}>{field.name}</span>;
      } else {
        assertAndContinue(false, `Could not find field: ${nameTemplatePart.fieldId}`);
        break;
      }
    }
    case NameTemplatePartType.COMPLEX_POLYMER_COMPONENT: {
      return (
        <span className={css(nameTemplatePartChipStyles.fieldName)}>{nameTemplatePart.displayName}</span>
      );
    }
    case NameTemplatePartType.CHILD_ENTITY_LOT_NUMBER: {
      const field = _.findWhere(schemaFields, {apiId: nameTemplatePart.fieldId});
      if (field) {
        return (
          <div>
            <span className={css(nameTemplatePartChipStyles.fieldName)}>{field.name}</span> Lot number
          </div>
        );
      } else {
        assertAndContinue(false, `Could not find parent link field: ${nameTemplatePart.fieldId}`);
        text = '(Unknown) Lot number';
        break;
      }
    }
    case NameTemplatePartType.LINKED_BIOENTITY_REGISTRY_IDENTIFIER: {
      const field = _.findWhere(schemaFields, {apiId: nameTemplatePart.fieldId});
      if (field) {
        return (
          <div>
            <span className={css(nameTemplatePartChipStyles.fieldName)}>{field.name}</span> Registry ID
          </div>
        );
      } else {
        assertAndContinue(false, `Could not find field: ${nameTemplatePart.fieldId}`);
        text = '(Unknown) Registry ID';
        break;
      }
    }
    case NameTemplatePartType.TEXT:
    case NameTemplatePartType.SEPARATOR:
      return (
        <span className={css(nameTemplatePartChipStyles.text)}>{ellipsize(nameTemplatePart.text, 50)}</span>
      );
    default: {
      text = getNameTemplatePartTypeToString(nameTemplatePart);
    }
  }
  return <div>{text}</div>;
}
